import { TextField } from '@flos/react-ui';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilState, useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { type CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import { useState } from 'react';
import { getCoverableIndex } from '../../../../utils/coverablesUtil';
import { track } from '../../../../utils/trackingUtil';
import { useHippoText } from '../../../../hooks/useHippoText';

const CatNameStep = ({ goNext }: { goNext: () => void }): React.JSX.Element => {
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const [coverables, setCoverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const getHippoText = useHippoText();

    const { cats = [] } = coverables;
    const coverableIndex = getCoverableIndex(cats, currentProduct.fixedId);
    const coverable = cats[coverableIndex];

    const [catName, setCatName] = useState<string>(coverable.name ?? '');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleCatNameBlur = (): void => {
        const updatedCoverables = [...cats];

        updatedCoverables[coverableIndex] = {
            ...updatedCoverables[coverableIndex],
            name: catName
        };

        setCoverables((prev) => ({
            ...prev,
            cats: updatedCoverables
        }));
    };

    const isValid = catName !== '';

    const onNext = (): void => {
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            cat: {
                publicId: coverable.publicId,
                fixedId: coverable.fixedId,
                name: coverable.name
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${coverable.flavourName}CoverableInformationNameOfCat`, [
                { name: coverable.name }
            ]);
            setIsLoading(false);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            hidePrevious
            disableNext={!isValid || isLoading}
            isNextLoading={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-PET-COVERABLE-INFORMATION-CAT-NAME-QUESTION')}
            >
                <TextField
                    label={getHippoText('DSS-PET-COVERABLE-INFORMATION-PET-NAME-INPUT-TOOLTIP')}
                    value={catName}
                    onChange={(event) => {
                        setCatName(event.target.value);
                    }}
                    onBlur={handleCatNameBlur}
                    minLength={1}
                    required
                    disabled={isLoading}
                />
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default CatNameStep;
